module.exports = __webpack_public_path__ + "e9dd18e614bf4cb424eabd6d5e15fc7b.fbx";